import * as yup from 'yup';

import ERROR_MESSAGE, { errorDocMaxSize } from '@/constants/errors.constants';
import type { FormValues, IDocumento, IDocumentoForm } from '@/interfaces/model/don.interface';
import { bytesToMB, checkMagicNumbersDocument } from '@/utils/file.utils';

import { getAllDocumentForm } from './formSolicitudes';

const documentoSchema = () =>
	yup
		.object()
		.test('binario-valido', ERROR_MESSAGE.docInvalidBinary, (value) => {
			const data = (value as IDocumentoForm) ?? {};
			const { contenidoBase64, rawFile, mimeType } = data;

			if (rawFile && contenidoBase64) {
				const extensionReal = rawFile.name.split('.').pop()?.toLowerCase();
				const tipoAValidar = extensionReal === 'gml' ? 'gml' : mimeType?.extension;

				if (tipoAValidar) {
					return checkMagicNumbersDocument({ rawFile, returnBase64: contenidoBase64 }, [tipoAValidar]);
				}
			}
			return true;
		})
		.test('documento-valido', ERROR_MESSAGE.docInvalidLength, (value) => {
			const data = value as IDocumentoForm;
			if (data?.nombre) {
				return data.nombre.length < 200;
			}
			return true;
		});

/**
 * Valida que el peso total acumulado de todos los documentos del formulario no supere el límite máximo permitido (maxSizeAllDoc).
 */
const documentoLimitadoSchema = ({
	maxSizeAllDoc,
	globalValues,
}: {
	maxSizeAllDoc: number;
	globalValues?: FormValues;
}) =>
	documentoSchema().test('peso-maximo', errorDocMaxSize(bytesToMB(maxSizeAllDoc)), function (value) {
		const newValue = value as IDocumento;
		const context = this as yup.TestContext<FormValues>;
		const globalValuesContext = context?.from?.[1]?.value as FormValues;
		const data = globalValues ?? globalValuesContext;

		const documentos = getAllDocumentForm(data);

		// Si los globalValues son externos, entonces hay que añadir el nuevo documento ya que no se encontrará entre estos.
		if (globalValues) {
			documentos.push(newValue);
		}

		const sizeAllDoc = documentos.filter(Boolean).reduce((acc, curr) => acc + curr.tamano, 0);

		return sizeAllDoc < maxSizeAllDoc;
	}) as unknown as yup.ObjectSchema<IDocumentoForm>;

export { documentoLimitadoSchema, documentoSchema };
